<template>
  <div class="wrapper">
    <CRow class="mt-3">
      <CCol sm="12" lg="4">
        <CCard>
          <CCardHeader>
            <b>Banner Form</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <strong>Title</strong>
                <b-input
                  v-model="form.title"
                  placeholder="Title"
                  id="banner-title"
                  class="mb-1"
                  :class="errors.title ? 'is-invalid' : ''"
                ></b-input>
                <b-form-invalid-feedback>
                  Title is required
                </b-form-invalid-feedback>
              </CCol>
            </CRow>
            <CRow class="mt-3">
              <CCol>
                <strong>Banner Image</strong>
                <p class="text-muted mb-2">Recommended aspect ratio 2:1 (e.g., 600×300).</p>
                <div class="mb-3">
                  <img
                    v-if="displayImage"
                    :src="displayImage"
                    class="img-preview"
                    alt="Banner preview"
                  >
                </div>
                <b-form-file
                  v-model="form.image"
                  plain
                  @input="handleFileChange"
                  :class="errors.image ? 'is-invalid' : ''"
                  accept="image/*"
                ></b-form-file>
                <b-form-invalid-feedback>
                  Please choose an image file
                </b-form-invalid-feedback>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol sm="12" lg="8">
        <CCard>
          <CCardBody>
            <CRow class="mt-3">
              <CCol>
                <label>Rich Text</label>
                <editor
                  id="banner-editor"
                  v-model="form.rich_text"
                  api-key="hq3wl53w9617r84m5cjgkm5h18xckn5mtfl0bvlkkytchrv8"
                  :init="init"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
        <CButton
          v-if="btn_create"
          block
          type="submit"
          color="info"
          :disabled="loading"
          @click.prevent="create"
        >
          <b>Create</b>
        </CButton>
        <CButton
          v-if="btn_update"
          block
          type="submit"
          color="info"
          :disabled="loading"
          @click.prevent="update(form.id)"
        >
          Update
        </CButton>
      </CCol>
    </CRow>
    <br><br>
    <alertmodal></alertmodal>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { BTooltip } from 'bootstrap-vue'
import Editor from '@tinymce/tinymce-vue'
import EventBus from '@/eventBus'
import alertmodal from '@/views/alert/modal.vue'
import banner from '@/services/banner'

Vue.component('b-tooltip', BTooltip)

export default {
  name: 'bannerform',
  components: {
    alertmodal,
    editor: Editor,
  },
  data() {
    return {
      errors: {},
      errors_from_backend: [],
      loading: false,
      form: {
        id: '',
        title: '',
        image: null,
        image_meta: null,
        rich_text: '',
      },
      btn_create: 0,
      btn_update: 0,
      imagePreview: '',
      init: {
        height: 500,
        init_instance_callback(editor) {
          const freeTiny = document.querySelector('.tox .tox-notification--in')
          if (freeTiny) {
            freeTiny.style.display = 'none'
          }
        },
        plugins: [
          'advlist autolink lists link image charmap',
          'searchreplace visualblocks',
          'insertdatetime table paste code wordcount',
          'autosave',
        ],
        toolbar:
          'restoredraft | undo redo | formatselect | bold italic forecolor | ' +
          'alignleft aligncenter alignright alignjustify | ' +
          'bullist numlist outdent indent | removeformat',
        autosave_interval: '1s',
        images_upload_credentials: true,
        images_upload_handler(blobInfo, success, failure) {
          const xhr = new XMLHttpRequest()
          const formData = new FormData()
          xhr.withCredentials = false
          xhr.open('POST', `${process.env.VUE_APP_URL}/upload_image_tinymce`)
          xhr.onload = function onload() {
            if (xhr.status !== 200) {
              failure(`HTTP Error: ${xhr.status}`)
              return
            }
            const json = JSON.parse(xhr.responseText)
            if (!json || typeof json.location !== 'string') {
              failure(`Invalid JSON: ${xhr.responseText}`)
              return
            }
            success(json.location)
          }
          formData.append('file', blobInfo.blob(), blobInfo.filename())
          xhr.send(formData)
        },
      },
    }
  },
  computed: {
    displayImage() {
      if (this.imagePreview) {
        return this.imagePreview
      }
      if (this.form.image_meta) {
        return this.resolveImageSource(this.form.image_meta)
      }
      return ''
    },
  },
  mounted() {
    this.loadData()
  },
  beforeDestroy() {
    if (this.imagePreview) {
      URL.revokeObjectURL(this.imagePreview)
    }
  },
  methods: {
    loadData() {
      if (this.$route.query.id) {
        this.btn_update = 1
        banner.getBannerbyID(this.$route.query.id)
          .then((res) => {
            const payload = res.data ? res.data : res
            this.form.id = payload.id || ''
            this.form.title = payload.title || ''
            this.form.rich_text = payload.rich_text || ''
            this.form.image_meta = payload.image || payload.banner_image || payload.bg_image || ''
          })
          .catch((err) => {
            const params = {
              title: 'Error',
              mode: 'danger',
              data: err.response && err.response.data ? err.response.data.message : err.message,
            }
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      } else {
        this.btn_create = 1
      }
    },
    create() {
      this.clearErrors()
      if (!this.validateForm(true)) {
        return
      }
      const formData = this.buildFormData()
      this.loading = true
      banner.createBanner(formData)
        .then((res) => {
          this.loading = false
          const message = res.message || 'Banner created'
          EventBus.$emit('TABLE_UPDATE_BANNER', true)
          EventBus.$emit('OPEN_MODAL_ALERT', { title: 'Success', mode: 'success', data: message })
          setTimeout(() => {
            this.$router.push({ name: 'Banner Table' })
          }, 1500)
        })
        .catch((err) => {
          this.loading = false
          this.handleBackendError(err)
        })
    },
    update(id) {
      this.clearErrors()
      if (!this.validateForm(false)) {
        return
      }
      const formData = this.buildFormData()
      this.loading = true
      banner.updateBanner(id, formData)
        .then((res) => {
          this.loading = false
          const message = res.message || 'Banner updated'
          EventBus.$emit('TABLE_UPDATE_BANNER', true)
          EventBus.$emit('OPEN_MODAL_ALERT', { title: 'Success', mode: 'success', data: message })
        })
        .catch((err) => {
          this.loading = false
          this.handleBackendError(err)
        })
    },
    buildFormData() {
      const formData = new FormData()
      formData.append('title', this.form.title)
      formData.append('rich_text', this.form.rich_text || '')
      if (this.form.image instanceof File) {
        formData.append('image', this.form.image)
      }
      return formData
    },
    handleFileChange(file) {
      if (this.imagePreview) {
        URL.revokeObjectURL(this.imagePreview)
        this.imagePreview = ''
      }
      if (file instanceof File) {
        this.imagePreview = URL.createObjectURL(file)
      } else if (!file) {
        this.form.image = null
      }
    },
    resolveImageSource(value) {
      if (!value) {
        return ''
      }
      if (typeof value === 'string') {
        if (value.startsWith('http')) {
          return value
        }
        return `${axios.defaults.baseURL}/getfile/${value}`
      }
      if (value.path && value.filename) {
        return `${axios.defaults.baseURL}/getfile/${value.path}/${value.filename}`
      }
      if (value.url) {
        return value.url
      }
      return ''
    },
    validateForm(requireImage) {
      let valid = true
      if (!this.form.title) {
        this.errors.title = true
        valid = false
      }
      if (requireImage && !(this.form.image instanceof File)) {
        this.errors.image = true
        valid = false
      }
      return valid
    },
    clearErrors() {
      this.errors = {}
      this.errors_from_backend = []
    },
    handleBackendError(err) {
      if (err.response && err.response.data) {
        const { message, errors } = err.response.data
        if (errors) {
          this.errors_from_backend = errors
        }
        EventBus.$emit('OPEN_MODAL_ALERT', { title: 'Error', mode: 'danger', data: message })
      } else {
        EventBus.$emit('OPEN_MODAL_ALERT', { title: 'Error', mode: 'danger', data: err.message })
      }
    },
  },
}
</script>

<style>
.img-preview {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  border: 1px solid #e4e5ea;
}
</style>
